export const TABS_ERRORS = {
  context: 'Tabs component was not found in the tree',
  value: 'Tabs.Tab or Tabs.Panel component was rendered with invalid value or without value',
};
